// extracted by mini-css-extract-plugin
module.exports = {"pageContent":"StrategyGroups_pageContent__1Hqdn"};